/**
 * Start Plan Trigger Component
 *
 * Trigger: "started a plan" (alias for plan-started)
 * Shows: plan select
 */

import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { fetchWorkoutPlanOptions } from 'src/models/workout-plan/workout-plan';
import { FormSelect } from 'src/shared/Forms/Fields/FormSelect';

import { TriggerComponentProps } from '../automationTriggers';

export const StartPlanTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();
  const { data: plans = [] } = useQuery({
    queryKey: ['workout-plans', 'options'],
    queryFn: () => fetchWorkoutPlanOptions(),
    staleTime: 60000,
  });

  const planOptions = plans.map((plan) => ({
    value: String(plan.id),
    label: plan.name,
  }));

  const selectedPlan = plans.find(
    (p) => String(p.id) === String(automation.reminderTypeId)
  );

  if (readOnly) {
    if (selectedPlan?.name) {
      return <span>{t('automations.triggers.startedPlanNamed', { plan: selectedPlan.name })}</span>;
    }
    return <span>{t('automations.triggers.startedPlan')}</span>;
  }

  // Edit mode
  return (
    <Box sx={{ maxWidth: 300 }}>
      <FormSelect
        name={`automations.${index}.reminderTypeId`}
        label={t('automations.triggerLabels.plan')}
        options={planOptions}
        prompt={t('automations.triggerLabels.selectPlan')}
      />
    </Box>
  );
};
